const API_BASE_URL = 'https://api.realitni-jestrab.cz'
const ACCESS_TOKEN_KEY = 'realitni_access_token'

export const feasibilityService = {
  async savePropertyFeasibility(propertyId, feasibility) {
    const response = await fetch(`${API_BASE_URL}/api/property/${encodeURIComponent(propertyId)}/feasibility`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN_KEY)}`,
      },
      body: JSON.stringify({ feasibility }),
    })

    const body = await response.json().catch(() => ({}))
    if (!response.ok) throw new Error(body.message || `HTTP error! status: ${response.status}`)
    return body.property
  },

  async previewFlatFlip(payload) {
    const response = await fetch(`${API_BASE_URL}/api/feasibility/flat-flip/preview`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN_KEY)}`,
      },
      body: JSON.stringify(payload),
    })

    const body = await response.json().catch(() => ({}))
    if (!response.ok) throw new Error(body.message || `HTTP error! status: ${response.status}`)
    return body
  },
}
